import { render, staticRenderFns } from "./AsignacionPersonal.vue?vue&type=template&id=581d4bfd&"
import script from "./AsignacionPersonal.vue?vue&type=script&lang=ts&"
export * from "./AsignacionPersonal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports